<section class="publications" id="publications" *ngIf="showBlock">
  <div class="container">
    <div class="row header-wrapper_mobile mb-4">
      <div class="col-12 d-flex flex-column">
        <h2>Wellness Insights</h2>
        <p>Explore scientifically grounded insights and practical guidance for mental well-being.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-publication-item [moreLabel]="'Read more'"
                              [showDescription]="true"
                              [itemData]="findElementByHeaderPosition(1)"></app-publication-item>
      </div>
      <div class="col-md-12 col-lg-7 d-flex flex-column justify-content-between">
        <div class="row ">
          <div class="col-md-12 col-lg-6"></div>
          <div class="col-md-12 col-lg-6">
            <app-publication-item [showDescription]="true"
                                  [square]="true"
                                  [moreLabel]="'Read more'"
                                  [itemData]="findElementByHeaderPosition(2)"></app-publication-item>
          </div>
        </div>

        <div class="row header-wrapper mt-5 mb-5">
          <div class="col-12 d-flex flex-row align-items-end">
            <h2 class="m-0 pr-3">Wellness Insights</h2>
            <p>Explore scientifically grounded insights and practical guidance for mental well-being.</p>
          </div>
        </div>
        <div class="row inline-items">
          <div class="col-6">
            <app-publication-item
                    [square]="true"
                    [moreLabel]="'Read more'"
                    [itemData]="findElementByHeaderPosition(3)"></app-publication-item>
          </div>
          <div class="col-6">
            <app-publication-item
                    [square]="true"
                    [moreLabel]="'Read more'"
                    [itemData]="findElementByHeaderPosition(4)"></app-publication-item>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="line"></div>
      </div>
    </div>
  </div>
</section>

